import React from 'react';
const POSTER_IMG = 'https://www.apc360zone.com/uploaded%2Fimages%2FTraining%20Announcements%2FAPRIL%202026%20Concealed%20Carry%20Training%20in%20New%20Jersey.png';
export function UpcomingClasses() {
  return <section className="py-16 md:py-24 bg-brand-black" data-id="element-302">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-303">
        <div className="text-center mb-12 md:mb-16 max-w-4xl mx-auto mb-12" data-id="element-304">
          <h2 className="text-3xl md:text-5xl font-extrabold text-brand-white uppercase tracking-wider mb-4" data-id="element-305">
            Upcoming Classes for Concealed Carry
          </h2>
          <div className="w-16 h-0.5 bg-brand-teal mx-auto" data-id="element-306" />
        </div>

        <div className="inline-block relative p-2 border border-brand-gray-700 bg-brand-gray-900 max-w-2xl mx-auto" data-id="element-307">
          <a href="/training" data-id="element-308">
            <img src={POSTER_IMG} alt="Concealed Carry Training" className="block w-full h-auto object-cover hover:opacity-90 transition-opacity" data-id="element-309" />
          </a>
          <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-brand-teal z-10" data-id="element-310" />
          <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-brand-teal z-10" data-id="element-311" />
          <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-brand-teal z-10" data-id="element-312" />
          <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-brand-teal z-10" data-id="element-313" />
        </div>
      </div>
    </section>;
}